import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';
import ReferenceBox from '../../common/reference-box';
import Button from '../../common/button/button';
import articleTagsService from '../../../services/article-tags/article-tags';

import './open-source-section.css';

export default class OpenSourceSection extends Component {
  render() {
    let extraJSX;

    const { openSourceProjects } = this.props;

    if (!openSourceProjects) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (openSourceProjects.length === 0) {
        extraJSX = (
          <div>
            <p>There are no projects</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='open-source-projects-container'>
            <div className='open-source-projects'>
              {
                openSourceProjects.map((openSourceProject, i) => 
                  <div key={ `open-source-project-${i}` } className='little-grow-animation'>
                    <OpenSourceProjectBox { ...openSourceProject } />
                  </div>
                )
              }
            </div>

            <Link to='/open-source' title='Open Source'>
              <Button 
                label='Explore More'
                isDark={ this.props.className !== 'dark' } />
            </Link>  
          </div>
        );
      }
    }

    return (
      <section className={ `${ this.props.className } section-container open-source-section-container` }>
        <h3 className='section-title'>
          Open Source
        </h3>

        { extraJSX }
      </section>
    );
  }
}

function getImageAndTags({ _id, demos, relatedArticles }) {
  if (demos.length) {
    return {
      imgUrl: `/images/open-source/${ _id }/${ demos[0]._id }.gif`,
      tags: demos[0].tags || [],
    };
  }

  if (relatedArticles.length) {
    return {
      imgUrl: `/images/articles/${ relatedArticles[0]._id }/summary.png`,
      tags: relatedArticles[0].tags || [],
    };
  }

  return { imgUrl: '', tags: [] };
}

function OpenSourceProjectBox(props) { 
  const { repoLink, } = props;

  const { imgUrl, tags } = getImageAndTags(props);
  const relevantTags = articleTagsService.getRelevantRecommendationsTags(tags);

  return (
    <div className='open-source-project-box little-grow-animation'>
      <ReferenceBox 
        { ...props }
        link={ repoLink }
        imgSrc={ imgUrl }
        isExternalResource={ true }
        tags={ relevantTags } />
    </div>
  );
}